'use strict';
/* ==========================================================================
   levels/map.js — the hub as a CASE BOARD (DESIGN.md §2): a cork board on the detective's desk; one evidence card per
   lesson.json step (a new step shows up by itself), pinned and joined by red thread; a CASE CLOSED stamp and the score
   on each finished one (Game.progress.scores[id] = {best, of}); a red "next!" arrow on the first card not closed yet.
   Along the bottom, the evidence and BUSTED cards the student has collected (HeatKit.cards(): Game.progress.cards),
   with an empty dashed slot for each one still to win (HeatKit.allCards(): every props.card of content/labs.json).
   Dr. Voss + a speech bubble (captions only; no voice). A card → Game.replace(new Levels[id]()); keys 1–4, Enter = next.
   On a phone held upright the steps are rows in the portrait dock (Dock.map) and the board is only the picture.
   ========================================================================== */
(function () {
  const POS = [{ x: 330, y: 400, rot: -0.04 }, { x: 770, y: 370, rot: 0.03 }, { x: 1210, y: 410, rot: -0.025 }, { x: 1645, y: 370, rot: 0.035 }];
  const CW = 400, CH = 260;
  const BAND = ['#e0533d', '#f2b33d', '#2e9c8e', '#8cc7d9'];
  const ROW = { x0: 260, y: 830, dx: 196, s: 0.44 };
  const SAY = {
    hello: 'Four cases on the board. Start with the missing joules.',
    next: 'Next case: the card with the arrow. Bring evidence, not theories.',
    done: 'Every case closed. Not one joule went missing.',
  };
  const steps = () => ((Game.lesson && Game.lesson.steps) || []).map((s, i) => Object.assign({ n: i + 1 }, s, POS[i % POS.length]));
  const nextStep = () => steps().find(s => !(Game.progress.stamps || {})[s.id]);

  function board() {
    g.fillStyle = paperTile('#5d4330', 4, 'tex_kraft'); g.fillRect(0, 0, Game.W, Game.H);
    g.fillStyle = '#3f2d1f'; g.fillRect(36, 36, 1848, 1008);                          // the frame
    g.fillStyle = paperTile('#b0814f', 3, 'tex_kraft'); g.fillRect(56, 56, 1808, 968);  // cork
    g.save(); g.fillStyle = 'rgba(30,18,8,0.18)'; for (let i = 0; i < 90; i++) { const x = 60 + (i * 397) % 1800, y = 60 + (i * 211) % 960; g.fillRect(x, y, 3, 2); } g.restore();
  }
  function thread(a, b, seed) {
    const mx = (a.x + b.x) / 2, my = Math.max(a.y, b.y) + 60;
    g.save(); g.strokeStyle = '#b3261e'; g.lineWidth = 4; g.lineCap = 'round';
    g.beginPath(); g.moveTo(a.x, a.y); g.quadraticCurveTo(mx + jit(seed, 2), my, b.x, b.y); g.stroke();
    g.strokeStyle = 'rgba(255,255,255,0.25)'; g.lineWidth = 1.5; g.beginPath(); g.moveTo(a.x, a.y - 1); g.quadraticCurveTo(mx, my - 1, b.x, b.y - 1); g.stroke();
    g.restore();
  }
  function scoreLine(s) {
    const sc = (Game.progress.scores || {})[s.id];
    if (!sc || sc.best == null) return null;
    if (s.id === 'melt') return `${sc.best} / ${sc.of || 3} deliveries`;
    return `${sc.best} / ${sc.of} rounds`;
  }
  function drawCard(s, hover, t0, stamped) {
    const sp = pop(T, t0 + 0.3 + s.n * 0.12, 0.4, 2.0);
    if (sp <= 0) return;
    g.save(); g.translate(s.x, s.y + (hover ? -8 : 0)); g.rotate(s.rot + (hover ? -0.012 : 0)); g.scale(sp * (hover ? 1.03 : 1), sp * (hover ? 1.03 : 1));
    paperRect(0, 0, CW, CH, '#fffdf7', { seed: 1300 + s.n, depth: hover ? 2 : 1.3, boil: false });
    paperRect(0, -CH / 2 + 24, CW - 16, 34, BAND[(s.n - 1) % 4], { seed: 1310 + s.n, depth: 0, boil: false });
    HeatKit.text(`CASE ${s.n}`, -CW / 2 + 22, -CH / 2 + 25, 24, { color: '#fffdf7' });
    paperCircle(-CW / 2 + 60, -8, 42, BAND[(s.n - 1) % 4], { seed: 1320 + s.n, depth: 0.6, boil: false });
    HeatKit.text(String(s.n), -CW / 2 + 60, -4, 60, { face: 'big', align: 'center', color: '#fffdf7' });
    const lines = HeatKit.wrap(s.title, 46, 'hand', CW - 140);
    lines.slice(0, 2).forEach((l, i) => HeatKit.text(l, -CW / 2 + 120, -8 + (i - (lines.length > 1 ? 0.5 : 0)) * 46, 46, { face: 'hand' }));
    if (!stamped) HeatKit.wrap(s.tag || '', 21, 'type', CW - 40).slice(0, 2).forEach((l, i) => HeatKit.text(l, -CW / 2 + 20, CH / 2 - 52 + i * 25, 21, { color: '#5b4a3a' }));
    g.restore();
    HeatKit.drawPart('pin', s.x, s.y - CH / 2 + 22, 0, 1);
  }

  class MapScene extends Scene {
    enter() {
      const st = Game.progress.stamps || {}, S = steps();
      this.allDone = S.every(s => st[s.id]);
      this.say = this.allDone ? SAY.done : S.some(s => st[s.id]) ? SAY.next : SAY.hello;
      this.stampNew = Game._justStamped; Game._justStamped = null;
      HeatKit.load();
      Audio.play('paper', { gain: 0.5 });
      if (Game.MUSIC) Audio.music(Game.MUSIC, { gain: 0.3 });
    }
    open(id) {
      Audio.play('pop', { gain: 0.6 });
      const C = Levels[id];
      if (typeof C === 'function') Game.replace(new C());
      else UI.toast('coming soon');
    }
    keyDown(k) {
      const S = steps(), n = parseInt(k, 10);
      if (n >= 1 && n <= S.length) this.open(S[n - 1].id);
      if (k === 'Enter') this.open((nextStep() || S[0]).id);
    }

    draw() {
      UI.allLessons();                       // "← All lessons": back to the site's home page (core/ui.js)
      const t0 = this.enteredAt, t = this.t, docked = UI.docked(), S = steps(), stamps = Game.progress.stamps || {};
      board();
      ransom('CASE BOARD', 960, 100, 60, t0 + 0.1, { seed: 404 });
      HeatKit.text('The Big Drop II · where did the heat go?', 960, 168, 28, { align: 'center', color: '#fbf3df' });
      // the red thread between the pins
      for (let i = 1; i < S.length; i++) thread({ x: S[i - 1].x, y: S[i - 1].y - CH / 2 + 2 }, { x: S[i].x, y: S[i].y - CH / 2 + 2 }, 40 + i);
      if (docked) Dock.map({ say: this.say, who: (LessonHooks.speakers && LessonHooks.speakers.voss || {}).name || 'Dr. Voss', open: id => this.open(id) });
      const nx = nextStep();
      S.forEach(s => {
        const hit = docked ? { hover: false, clicked: false } : UI._hit('tag' + s.n, s.x, s.y, CW, CH);
        if (hit.hover && !this['hov' + s.n]) Audio.play('paper', { gain: 0.2, rate: 1.3 });
        this['hov' + s.n] = hit.hover;
        drawCard(s, hit.hover, t0, !!stamps[s.id]);
        if (stamps[s.id]) {
          let sc = 1;
          if (this.stampNew === s.id) {
            const at = t0 + 0.9;
            sc = pop(T, at, 0.18, 1.2) * (1 + 1.4 * (1 - P(T, at, at + 0.12)));
            if (T >= at && !this.stampPlayed) { this.stampPlayed = true; Audio.play('stamp_case', { gain: 0.8 }); }
          } else sc = pop(T, t0 + 0.8, 0.25, 1.5);
          UI.stamp('CASE CLOSED', s.x + 10, s.y + CH / 2 - 52, { rot: -0.06, s: sc * 0.46, color: '#c0392b' });
          const line = scoreLine(s);
          if (line && sc > 0) HeatKit.text(line, s.x, s.y + CH / 2 + 30, 26, { align: 'center', color: '#fbf3df', outline: 'rgba(43,36,32,0.85)' });
        }
        if (!this.allDone && nx === s) {
          const ns = pop(T, t0 + 1.4, 0.4), bob = Math.sin(T * 4) * 8;
          if (ns > 0) {
            g.save(); g.globalAlpha = ns;
            inkArrow(s.x + 40 + bob, s.y + CH / 2 + 110, s.x + 10 + bob, s.y + CH / 2 + 18, { w: 6, color: '#fbe3b0', seed: 600 + s.n, bulge: -20 });
            hand('next!', s.x + 90 + bob, s.y + CH / 2 + 104, 46, 0, { dur: 0.01, color: '#fbe3b0', rot: 0.08, seed: 610 + s.n, outline: 'rgba(43,36,32,0.8)' });
            g.restore();
          }
        }
        if (hit.clicked) this.open(s.id);
      });
      // the evidence collected: pinned along the bottom; a dashed slot for each card still to win
      const all = HeatKit.allCards(), have = HeatKit.cards();
      HeatKit.text(`Evidence collected: ${have.filter(id => all.includes(id)).length} of ${all.length}`, ROW.x0 - 120, ROW.y - 110, 28, { color: '#fbf3df', outline: 'rgba(43,36,32,0.85)' });
      all.forEach((id, i) => {
        const x = ROW.x0 + i * ROW.dx, y = ROW.y + (i % 2 ? 14 : -6), rot = ((i * 37) % 7 - 3) * 0.012;
        if (have.includes(id)) {
          const s = pop(T, t0 + 0.6 + i * 0.06, 0.35, 1.8);
          if (s > 0) { HeatKit.card(id, x, y, { s: ROW.s * s, rot, small: true }); HeatKit.drawPart('pin', x, y - 240 * ROW.s / 2 + 8, 0, 0.7); }
        } else {
          g.save(); g.translate(x, y); g.rotate(rot); g.setLineDash([10, 8]); g.lineWidth = 3; g.strokeStyle = 'rgba(251,243,223,0.55)';
          g.strokeRect(-180 * ROW.s, -120 * ROW.s, 360 * ROW.s, 240 * ROW.s); g.restore();
          HeatKit.text('?', x, y + 4, 44, { face: 'big', align: 'center', color: 'rgba(251,243,223,0.55)' });
        }
      });
      // Dr. Voss + her line
      const rise = E.outBack(P(T, t0 + 0.2, t0 + 0.7), 1.4);
      Puppet.draw('voss', 1770, 1075 + (1 - rise) * 500, 440, { facing: -1, t: T, pose: this.allDone ? 'point' : null, env: t > 0.6 && t < 3 ? 0.25 + 0.25 * Math.sin(T * 17) : 0 });
      if (t > 0.6 && !docked) UI.speech(this.say, 1240, 620, { side: 'right', w: 560, t0: t0 + 0.6 });
    }
  }
  /* the cards' centres (tools/integration.js clicks these) */
  MapScene.tags = () => steps().map(s => ({ id: s.id, x: s.x, y: s.y }));
  MapScene.ROW = ROW;

  Levels.map = MapScene;
})();
